import { render, staticRenderFns } from "./brand-assess-dialog.vue?vue&type=template&id=64b07b26&scoped=true&"
import script from "./brand-assess-dialog.vue?vue&type=script&lang=js&"
export * from "./brand-assess-dialog.vue?vue&type=script&lang=js&"
import style0 from "./brand-assess-dialog.vue?vue&type=style&index=0&id=64b07b26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b07b26",
  null
  
)

export default component.exports